import { onSignalREvent } from '../../signalRBus'
import { SIGNAL_R_MESSAGES, SIGNAL_R_SCOPES } from 'src/signalR/types'
import type { NewAnnouncementSignalRPayload } from 'src/signalR/types'
import { useMessagingServiceStore } from 'src/stores/messaging.service.store'

onSignalREvent(
  SIGNAL_R_SCOPES.message,
  SIGNAL_R_MESSAGES.newAnnouncement,
  (text, response) => {
    const payload: NewAnnouncementSignalRPayload = JSON.parse(text)
    const messagingServiceStore = useMessagingServiceStore()
    messagingServiceStore.handleNewAnnouncementEvent(
      payload,
      response.OrgId,
      response.CenterId,
    )
  },
)
